import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  { name: 'Dr. Sarah M.', role: 'Owner, Miami Aesthetic Med Spa', quote: 'Website Symphony rebuilt our med spa site and bookings tripled within the first 60 days. The before-and-after gallery alone was worth the investment.', rating: 5 },
  { name: 'Marcus J.', role: 'Owner, Ink District Tattoo Studio', quote: 'They built us a site that ranks #1 for tattoo shop searches in our city and finally gave us a way to collect deposits online. No more no-shows.', rating: 5 },
  { name: 'Ricardo T.', role: 'VP Operations, Coastal Construction Group', quote: 'Our new site helped us win two commercial contracts in the first quarter. The project portfolio and bid request forms actually work.', rating: 5 },
  { name: 'Amanda K.', role: 'Marketing Director, Gulf Energy Services', quote: 'Website Symphony understood our oilfield services business immediately. The capability statements and HSE stats are exactly where they need to be.', rating: 5 },
  { name: 'Jessica R.', role: 'Founder, Radiance Skin Studio', quote: 'The team walked us through every step. Booking integration with Boulevard was seamless. Highly recommend for any med spa.', rating: 5 },
  { name: 'Tomas V.', role: 'Head Artist, Neon Ink Collective', quote: 'Our artists love how easy it is to update their portfolios. Site is fast and looks incredible on mobile. Best decision we made this year.', rating: 5 },
];

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-[#D9A04A] tracking-[0.3em] text-sm font-semibold mb-3">CLIENT REVIEWS</h2>
          <h3 className="text-[#2C5F66] text-3xl md:text-4xl font-extrabold">Rated 5.0 by clients across the U.S.</h3>
          <div className="flex items-center justify-center gap-1 mt-4">
            {[1,2,3,4,5].map((s) => <Star key={s} size={22} className="text-[#D9A04A]" fill="#D9A04A" />)}
            <span className="ml-2 text-gray-600 font-medium">5.0 · 87 verified reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-[#F7F7F5] rounded-lg p-7 relative hover:shadow-lg transition-shadow">
              <Quote className="absolute top-4 right-4 text-[#D9A04A]/30" size={40} />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} size={14} className="text-[#D9A04A]" fill="#D9A04A" />
                ))}
              </div>
              <p className="text-gray-700 text-[15px] leading-relaxed mb-5">“{t.quote}”</p>
              <div>
                <p className="text-[#2C5F66] font-bold">{t.name}</p>
                <p className="text-gray-500 text-xs">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export const testimonialsData = testimonials;
export default Testimonials;
